import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './app/resources/css/reset.css'
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <App />
      </BrowserRouter>
  </React.StrictMode>
);